import { clone as e, DEFAULT_CHECKPOINT_SCHEMA as r, getPrimaryFieldOfPrimaryKey as t } from "rxdb-old2";
import { getIndexId as o } from "./sqlite-helpers";
import { mangoQuerySelectorToSQL as a, mangoQuerySortToSQL as i } from "./sqlite-query";
export var NON_IMPLEMENTED_OPERATOR_QUERY_BATCH_SIZE = 50;
export var RxStorageSQLiteStatics = {
  prepareQuery(r, p) {
    var E = t(r.primaryKey),
      m = p.limit ? "LIMIT " + p.limit : "LIMIT -1",
      I = p.skip ? "OFFSET " + p.skip : "",
      d = [],
      l = "",
      s = void 0,
      n = "";
    p.index && (n = 'INDEXED BY "' + o(p.index) + '"');
    var c = i(E, p.sort);
    try {
      var y = a(r, p.selector, d);
      l = n + " WHERE deleted=0 " + (y = "()" !== y ? " AND " + y + " " : "") + c + " " + m + " " + I + " ;";
    } catch (e) {
      if (!e.isNonImplementedOperatorError) throw e;
      d = [], s = e.operator, l = n + " WHERE deleted=0 " + c + " LIMIT " + NON_IMPLEMENTED_OPERATOR_QUERY_BATCH_SIZE + " ";
    }
    return {
      schema: r,
      mangoQuery: e(p),
      sqlQuery: {
        query: l,
        params: d,
        context: {
          method: "prepareQuery",
          data: {}
        }
      },
      queryWithoutSort: l.replace(c, " "),
      nonImplementedOperator: s
    };
  },
  checkpointSchema: r
};